import React from "react";
export const TripsContext = React.createContext();
